import { ButtonGroup } from '@vds/buttons'
import { Carousel } from '@vds/carousels'
import { Body, Title } from '@vds/typography'
import React, { useState, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import OffersCardComponent from '../../../components/Category/Offers/OffersCard'
import './RelatedSection.scss'
import SecondaryCourseCard from './SecondaryCourseCard/SecondaryCourseCard'
import { TileContainer } from '@vds/tiles'
import { Icon } from '@vds/icons'
import { useSelector } from 'react-redux';
import { decodeHTML, relatedResourcesCards, forcedRankingOffersTopics, mapperForCourseCxCard, getForceRankedCourses } from '../../../utility/utils';
import { cloneDeep } from 'lodash';
import { getRecommendedCourses } from '../../../utility/common.js';

const RelatedSection = ({isInPersonEvent, courseCxAemData, currentCourse, courseType, allCourses, allEventsAllWithTimeZone, allQuickTips, offersMock, selectedTopics, topicEnEsMaping, aemOffersContentForHeading, onUpdate,sectionKey}) => {
  
  const allLP = useSelector((state) => state.AdobeResources.learningPaths) ?? null;

  const allEventsWithTimeZone = allEventsAllWithTimeZone?.filter(e => new Date(e.startDate).getTime() >= new Date().getTime()) || [];
  const currentTags = currentCourse?.tags;
  const tags = currentTags?.filter((tag) => !tag.includes('instructor:') && !tag.startsWith('rel='));
  const relTag = currentTags?.find(tag => tag.startsWith('rel='));
  // const relTag = "rel=2321690|11116804|14064687|qt1|12464126|qt2"
  const relIds = relTag ? relTag.split('=')[1]?.split('|').map(id => id.trim().toLowerCase()) : [];
  const isRelTagAvailable = currentTags?.some(tag => tag.startsWith('rel='));
  // const isRelTagAvailable = true;
  
  const [secondaryCourseCardData, setSecondaryCourseCardData] = useState([])
  const [secondaryLpCards, setSecondaryLpCards] = useState([])
  const [finaloffers, setFinalOffers] = useState([]);
  const [resourceButtonData, setResourceButtonData] = useState([])
  const [recommendedCoursesData, setRecommendedCoursesData] = useState(null);
  const userLanguage = localStorage.getItem("lng") || 'en';
  const courseId = currentCourse?.id;
  const MAX_NUMBER_OF_TILES = 6;
  const isEvent = courseType.toLowerCase() === 'event';

 
  useEffect(() => {
    const fetchRecommendedCourses = async () => {
      const recCourse = await getRecommendedCourses();
      setRecommendedCoursesData(recCourse ?? null);
    };
    fetchRecommendedCourses();
  }, []);

  const getForceRankedCoursesForRelated = () => {
    if (recommendedCoursesData && allCourses && tags?.length > 0) {
      const rankedCourses = getForceRankedCourses(userLanguage,allCourses,tags,recommendedCoursesData,courseId,MAX_NUMBER_OF_TILES);
      const tagMatchedCourses = allCourses?.filter(
        e => e.id !== courseId && tags?.some(r => e.tags?.includes(r))
      );
      const rankedIds = new Set(rankedCourses.map(c => c.id));
      const unrankedCourses = tagMatchedCourses.filter(c => !rankedIds.has(c.id));
      return [...rankedCourses, ...unrankedCourses];
    }
    // Fallback: simple tag match (if recommendedCoursesData not yet loaded
    return allCourses?.filter(e => e.id !== courseId && tags?.some(r => e.tags?.includes(r))) ?? [];
  };

  // Creating Button Data
  useEffect(() => {
    const updateData = courseCxAemData?.relatedsection?.filterdetails?.map((button) => {
      return {
        children: button.label,
        ariaLabel: button.label,
        label: button.value,
        size: 'small',
        use: button.value == "All" ? 'primary': 'secondary',
        width: 'auto',
        onClick: () => handleButtonClick(button.value),
      };
    })
    setResourceButtonData(updateData)
  },[courseCxAemData, recommendedCoursesData])

  //You may interested resources carousal
  useEffect(() => {
    if (tags?.length > 0 && allCourses && allEventsWithTimeZone && allQuickTips) {
      if (isRelTagAvailable) {
        const transformedArray = relIds.map(item => {
          if (item.startsWith('qt')) {
            return item.slice(2);
          } else {
            return `course:${item}`;
          }
        });
        
        const relCourseIds = transformedArray?.filter(id => id.startsWith('course:'));
        const relQtIds = transformedArray?.filter(id => !id.startsWith('course:'));
        const filteredCourses = allCourses?.filter(course => relCourseIds?.includes(course.id?.toString()));
        const filteredEvents = allEventsWithTimeZone?.filter(event => relCourseIds?.includes(event.id?.toString()));
        const filteredQuickTips = allQuickTips?.combinedQuickTips?.filter(quickTip => relQtIds?.includes(quickTip.courseId?.toString()));
        
        updateResourceCardData(filteredCourses, filteredEvents, filteredQuickTips);
        updateResourceButtonData(filteredCourses, filteredEvents, filteredQuickTips);
      } else {
        const events = allEventsWithTimeZone?.filter(e => tags?.some(r => e.tags?.includes(r)));
        const courses = getForceRankedCoursesForRelated();
        const tips = allQuickTips?.combinedQuickTips?.filter(e => tags?.some(r => e.tags?.includes(r)));
        
        updateResourceCardData(courses, events, tips);
        updateResourceButtonData(courses, events, tips);
      }
    }
  }, [allEventsAllWithTimeZone, currentTags, courseId, allQuickTips, recommendedCoursesData]);

  const updateResourceCardData = (courses, events, tips) => {
    setSecondaryCourseCardData(relatedResourcesCards(courseId, MAX_NUMBER_OF_TILES, courses, events, tips)
      .map((resource) => {
        return mapperForCourseCxCard(resource, courseCxAemData);
      })
    );
  }

  const updateResourceButtonData = (courses, events, tips) => {
    setResourceButtonData(prevData => {
      let updatedData = [...prevData];
      if (!courses || courses.length === 0) {
        updatedData = updatedData?.filter(button => button.label !== 'Courses');
      }
      if (!events || events.length === 0) {
        updatedData = updatedData?.filter(button => button.label !== 'Events');
      }
      if (!tips || tips.length === 0) {
        updatedData = updatedData?.filter(button => button.label !== 'Quick tips');
      }
      return updatedData;
    });
  };

  // Learning Path Card Carousal Data
  useEffect(() => {
    if (allLP && courseCxAemData && courseId) {
      const prevUrl = localStorage.getItem('prevUrl');
      const learningPathId = prevUrl ? prevUrl.split('/').find(ele => ele.includes('learningProgram:')) : null;
      // const learningPathId = "learningProgram:125788"

      let MAX_NUMBER_OF_LP_TITLES = learningPathId?.length > 0 ? 5 : MAX_NUMBER_OF_TILES;

      if(learningPathId){
        const firstLPCard = allLP.filter(lp => lp.courseId === learningPathId)
        setSecondaryLpCards(firstLPCard?.map((resource) => {
          return mapperForCourseCxCard(resource, courseCxAemData);
        }))
      }

      const cardsByTopicInterest = allLP.filter(lp => tags?.some(r => lp.tags?.includes(r)) && lp?.instances?.some(instance => instance?.id == courseId) && (!learningPathId || lp?.courseId !== learningPathId) )
      const resInOtherLP = allLP.filter(lp =>lp?.instances?.some(instance => instance?.id == courseId) && (!learningPathId || lp?.courseId !== learningPathId));
      const filteredLP = Array.from(new Set([...cardsByTopicInterest, ...resInOtherLP]));

      setSecondaryLpCards(prev => [
        ...(prev || []),
        ...filteredLP?.slice(0, MAX_NUMBER_OF_LP_TITLES)?.map(resource => mapperForCourseCxCard(resource, courseCxAemData)),
      ]);
    }
  }, [allLP, courseCxAemData, courseId])

  const handleButtonClick = (type) => {
    setSecondaryCourseCardData([]);

    let courses =[]
    let events = []
    let tips = []

    if (isRelTagAvailable) {
      const transformedArray = relIds?.map(item => {
        if (item.startsWith('qt')) {
          return item.slice(2);
        } else {
          return `course:${item}`;}
      });
      const relCourseIds = transformedArray?.filter(id => id.startsWith('course:'));
      const relQtIds = transformedArray?.filter(id => !id.startsWith('course:'));
      courses = allCourses?.filter(course => relCourseIds?.includes(course.id?.toString()));
      events = allEventsWithTimeZone?.filter(event => relCourseIds?.includes(event.id?.toString()));
      tips = allQuickTips?.combinedQuickTips?.filter(quickTip => relQtIds?.includes(quickTip?.courseId?.toString()));
    } else {
      events = allEventsWithTimeZone?.filter(e => tags?.some(r => e.tags?.includes(r)));
      courses = getForceRankedCoursesForRelated();
      tips = allQuickTips?.combinedQuickTips?.filter(e => tags?.some(r => e.tags?.includes(r)));
    }

    if (type === 'Courses') {
      updateResourceCardData(courses, [], []);
    } else if (type === 'Events') {
      updateResourceCardData([], events, []);
    } else if (type === 'Quick tips') {
      updateResourceCardData([], [], tips);
    } else {
      updateResourceCardData(courses, events, tips);
    }

    setResourceButtonData((prevData) =>
      prevData.map((button) => ({
        ...button,
        use: button.label === type ? 'primary' : 'secondary',
      }))
    );
    updateResourceButtonData(courses, events, tips);
  };

  // Offers card Carousal Data
  // useEffect(()=> {
  //   if (tags && offersMock) {
  //     let filteredOffers = forcedRankingOffersTopics(offersMock,selectedTopics,12);
      
  //     const updatedTags = tags?.map(tag => 
  //       topicEnEsMaping?.find(mapping => mapping[1] === tag)?.[2] || tag
  //     );
  //     let final = filteredOffers?.filter((offer) => 
  //       !offer?.topics || offer?.topics?.some((topic) => updatedTags?.some((tag) => tag?.toLowerCase() === topic?.toLowerCase())) || offer.topics?.filter(item=>item!=='')?.length === 0
  //     );
  //     setFinalOffers(final);
  //   }
  // }, [offersMock, selectedTopics, location?.pathname]);

  // Offers card Carousal Data
  useEffect(()=> {
    if (tags?.length > 0 && offersMock?.forcedRanking) {
      
      // 1. Get the exact keys used in the CMS forced ranking data
      const forcedRankingKeys = Object.keys(offersMock.forcedRanking);

      // 2. Find the exact CMS key that matches your course's first tag, ignoring case
      const matchedTopicKey = forcedRankingKeys.find(key => 
        key.toLowerCase().replace(/[^\w]/g, '') === tags[0]?.toLowerCase().replace(/[^\w]/g, '')
      );

      let filteredOffers = [];
      
      // 3. Pass ONLY the perfectly matched string inside an array to bypass the topics[0] bug
      if (matchedTopicKey) {
        filteredOffers = forcedRankingOffersTopics(offersMock, [matchedTopicKey], 12);
      } else {
        // Fallback to "I'm not sure" list if no match is found
        filteredOffers = forcedRankingOffersTopics(offersMock, [], 12);
      }
      
      const updatedTags = tags?.map(tag => 
        topicEnEsMaping?.find(mapping => mapping[1] === tag)?.[2] || tag
      );
      
      let final = filteredOffers?.filter((offer) => 
        !offer?.topics || offer?.topics?.some((topic) => updatedTags?.some((tag) => tag?.toLowerCase() === topic?.toLowerCase())) || offer.topics?.filter(item=>item!=='')?.length === 0
      );
      console.log('final offers', final);
      setFinalOffers(final);
    }
  }, [offersMock, tags, topicEnEsMaping]);

  useEffect(() => {
    if (typeof onUpdate === 'function') {   
       onUpdate(resourceButtonData);     
    }
  }, [resourceButtonData, onUpdate]);
  
  return (
    <div className='related_section_extend_width'>
      <Title size='medium' bold>{decodeHTML(courseCxAemData?.relatedsection?.intertesttitle)}</Title>
      <div className='mt-8X sm-mt-6X'>
        <ButtonGroup
          viewPort={isMobile ? 'mobile' : 'desktop'}
          rowQuantity={{ desktop: 4 }}
          data={resourceButtonData}
          alignment={'left'}
        />
        {secondaryCourseCardData && secondaryCourseCardData.length > 0 && <div className='mt-8X sm-mt-6X interested_in_carousel'>
          <Carousel
            layout={isMobile ? "1UP" : "2UP"}
            gutter={isMobile ? "12px" : "24px"}
            surface="light"
            paginationFill="light"
            paginationInset="12px"
            paginationDisplay="persistent"
            peek={isMobile ? 'standard' : 'none'}
            viewportOverride={{
              mobile: {
                layout: "1UP",
              },
              mobileLarge: {
                layout: "1UP",
              },
              tablet: {
                layout: "2UP",
              },
              tabletLarge: {
                layout: "2UP",
              },
              desktop: {
                layout: "2UP",
              },
            }}
            data={secondaryCourseCardData}
            renderItem={(props) => (
              <SecondaryCourseCard sectionKey={sectionKey}  renditionType="related-resources" {...props} />
            )}
          />
        </div>}
        {secondaryLpCards && secondaryLpCards.length >0 && !isInPersonEvent && <div className={`mt-8X sm-mt-12X`}>
          <Title size="small" bold>{decodeHTML(courseCxAemData?.relatedsection?.learnpathtitle)}</Title>
          <div className='mt-8X sm-mt-4X interested_in_carousel'>
            {secondaryLpCards && secondaryLpCards.length > 0 && <Carousel
              layout={isMobile ? "1UP" : "2UP"}
              gutter={isMobile ? "12px" : "24px"}
              surface="light"
              paginationFill="light"
              paginationInset="12px"
              paginationDisplay="persistent"
              peek={isMobile ? 'standard' : 'none'}
              viewportOverride={{
                mobile: {
                  layout: "1UP",
                },
                mobileLarge: {
                  layout: "1UP",
                },
                tablet: {
                  layout: "2UP",
                },
                tabletLarge: {
                  layout: "2UP",
                },
                desktop: {
                  layout: "2UP",
                },
              }}
              data={secondaryLpCards?.map((data, index)=>({...data, arialabel:`Slide ${index +1} of ${secondaryLpCards?.length} `}))}
              renderItem={(props) => (
                <SecondaryCourseCard sectionKey={sectionKey} renditionType="related-learningPaths" {...props} />
              )}
            />}
          </div>
        </div>}
        {!isEvent && secondaryLpCards && secondaryLpCards.length >0 && !isInPersonEvent &&<div className='mt-8X sm-mt-6X resource_highlight'>
          <TileContainer
            padding={isMobile ? '16px' : '24px'}
            width="100%"
            height='100%'
            showDropShadow={true}
            role='coursedetailscontainer'
            backgroundColor="white"
          >
            <div className={` n-displayFlex`}>
              <Icon name='question' size='XLarge'></Icon>
              <div className='ml-3X'>
                <Title size='small'>{decodeHTML(courseCxAemData?.relatedsection?.ques)}</Title>
                <div className='mt-2X'>
                  <Body size='small'>{decodeHTML(courseCxAemData?.relatedsection?.answer)}</Body>
                </div>
              </div>
            </div>
          </TileContainer>
        </div>}
        {finaloffers && finaloffers?.length > 0 && <div className='mt-8X sm-mt-12X'>
          <Title size='small' bold>{aemOffersContentForHeading?.resourceDetailPageOfferTitle}</Title>
          <div className='mt-8X sm-mt-4X related_course_carousel'>
            {finaloffers && finaloffers.length > 0 && <Carousel
              layout={isMobile ? "1UP" : "2UP"}
              gutter={isMobile ? "12px" : "24px"}
              surface="light"
              paginationFill="light"
              paginationInset="12px"
              paginationDisplay="persistent"
              peek={isMobile ? 'standard' : 'none'}
              viewportOverride={{
                mobile: {
                  layout: "1UP",
                },
                mobileLarge: {
                  layout: "1UP",
                },
                tablet: {
                  layout: "2UP",
                },
                tabletLarge: {
                  layout: "2UP",
                },
                desktop: {
                  layout: "2UP",
                },
              }}
              data={finaloffers.map((item, index) => {
                let _item = cloneDeep(item)
                _item.bg='bg-monarch height-correct'
                _item.catBg = '#fff'
                return _item;
              })}
              renderItem={(props) => (
                <OffersCardComponent sectionKey ={sectionKey} data={props} />
              )}
            />}
          </div>
        </div>} 
      </div>
    </div>
  )
}

export default RelatedSection